<template>
    <div v-show="visible">
        <el-dialog title="预览" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="750px">    
            <div class="list-detail">
                <list :list="treeData"></list>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="visible=false">关闭</el-button>
            </span>    
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../../common/http';
    import List from './TreeCollapse.vue';

    export default {
        data(){
            return{
                visible: false,
                form:{
                    deptId:"",
                },
                rules: {
                },
                treeData:[]
            }
        },
        created:function () {
        },
        components: {
            List
        },
        methods:{
            init(deptId){
                this.visible=true;
                this.form.deptId=deptId;
                this.getData();
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            getData(){
                let url= this.teacherTemplateConfigPreviewUrl;
                let data = {
                    deptId:this.form.deptId
                };
                this.apiPost(url, data).then((res) => {
                    console.log(JSON.stringify(res.data));
                    if(res.status === 200){
                        this.treeData=res.data;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                }, (err) => {
                    console.log(err);
                });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/teacher/config/TemplateConfigInfo.vue